import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const icp = {
    jpath: ['spectra', 'icp'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default icp;
//# sourceMappingURL=icp.js.map